import '../scss/style.scss';

const CSS_CLASSES = {
	THUMBS: 'detail-slider__thumbs',
	MAIN: 'detail-slider__main',
	NEXT_BUTTON: 'detail-slider__next',
	PREV_BUTTON: 'detail-slider__prev'

};

class NewsDetailArticle
{
	constructor(element, options = {})
	{
		this.element = element;
		BX.ready(this.init.bind(this));
	}

	init()
	{
		if (window.Swiper == undefined)
			return;

		if (!this.element)
			return;

		this.thumb =  this.element.querySelector(`.${CSS_CLASSES.THUMBS}`);
		this.activePict = this.element.querySelector(`.${CSS_CLASSES.MAIN}`);

		this.initSlider();
		this.initFancybox();
	}

	initSlider()
	{
		if (window.Swiper == undefined)
			return;

		const prevOptions = {
			el: this.thumb,
			spaceBetween: 10,
			slidesPerView: 3,
			freeMode: true,
			watchSlidesProgress: true,
			loop: true,
		};

		this.sliderThumbs = new Swiper(prevOptions);

		const sliderOptions = {
			el: this.activePict,
			loop: true,
			spaceBetween: 10,
			navigation: {
			  nextEl: `.${CSS_CLASSES.NEXT_BUTTON}`,
			  prevEl: `.${CSS_CLASSES.PREV_BUTTON}`,
			},
			thumbs: {
			  swiper: this.sliderThumbs,
			},

		};

		this.sliderImages = new Swiper(sliderOptions);
	 }

	initFancybox()
	{
		this.activePict.addEventListener(
			'click',
			(event)=> {

				event.preventDefault();

				var target = event.target;

				if (target.tagName !== "IMG")
						return

				var sliderDiv = [...this.activePict.getElementsByClassName('swiper-slide')];

				if (!sliderDiv)
					return;

				sliderDiv = sliderDiv.filter(function(item) {
					return !item.classList.contains('swiper-slide-duplicate');
				});

				var imgThumbs = [...this.thumb.getElementsByClassName('swiper-slide')];

				if (!imgThumbs)
					return;

				imgThumbs = imgThumbs.filter(function(item) {
					return !item.classList.contains('swiper-slide-duplicate');
				});

				this.activSlide = this.activePict.querySelector('.swiper-slide-active').getAttribute('data-swiper-slide-index');

				Fancybox.show(
					sliderDiv.map(
						(item, index) => {
							return {
								src: item.querySelector('a')?.href,
								thumb: imgThumbs[index].querySelector('img')?.src,
							  }
						}
					),
					{
						startIndex: this.activSlide,
					}
				);
			}
		);
	}
}

export { NewsDetailArticle };
